exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-menu{display:inline-block;line-height:60px;height:60px;position:relative}.user-menu__dropdown-toggle{background:transparent!important;padding-top:0!important;padding-bottom:0!important}.user-menu__image{position:absolute;border-radius:50%;height:30px;width:30px;left:0;top:50%;transform:translateY(-50%)}.user-menu__welcome{color:#999;margin-left:40px}.user-menu__item{color:#333}.user-menu__item,.user-menu__item a{height:30px;line-height:30px}.user-menu__item-icon{color:#999;font-size:20px;vertical-align:middle;margin-right:10px;margin-top:-20px}.user-menu:after{content:'';border:0 solid #666;width:30px;height:30px;border-radius:50%;position:absolute;left:0;top:50%;transform:translateY(-50%)}.open .user-menu:after,.user-menu:hover:after{border-width:1px}.user-menu:hover .user-menu__welcome{color:#666}.divider{margin:4px 0!important}.user-menu__dropdown-toggle:hover{background:transparent!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/Header/components/UserMenuItem/style.css
 ** module id = 1951
 ** module chunks = 73
 **/